<template>
	<div class="whiteList">
     <van-nav-bar
      left-text="返回"
      left-arrow
      title="白名单"
      @click-left="onClickLeft"
    />
    <div class="item">
      <p>商户名称</p>
      <p>{{ info.mercName }}</p>
    </div>
    <div class="item">
      <p>商户编号</p>
      <p>{{ info.mercNo }}</p>
    </div>
    <div class="item">
      <p>白名单状态</p>
      <p>{{ info.checkStatus | formateStatus }}</p>
    </div>
    <div class="item">
      <p>申请时间</p>
      <p>{{ info.createTime || '无' }}</p>
    </div>
    <div class="item">
      <p>审核时间</p>
      <p>{{ info.checkTime || '无' }}</p>
    </div>
    <div class="item" v-if="info.checkStatus === '2'">
      <p>原因</p>
      <p>{{ info.checkRemark }}</p>
    </div>
    <button v-if="info.checkStatus !== '1'" class="btn" :disabled="isDisabled" @click="handleApply">
      {{ info.checkStatus | formateBtnText }}
    </button>
    <van-checkbox v-model="checked" class="checkBox" v-if="!isDisabled">
      <p>请您知晓勾选此选项即表示您方已认真履行特约商户调查职责，确保商户合法真实有效，
      否则因您方未充分履行特约商户调查职责造成我方或任意第三方的全部损失由您方承担。</p>
    </van-checkbox>
  </div>
</template>

<script>
import { Checkbox, Dialog } from 'vant';
export default {
  name: 'whiteList',
  components: {
    [Checkbox.name]: Checkbox,
    [Dialog.name]: Dialog
  },
  computed: {
    isDisabled: function() {
      return this.info.checkStatus === '0' || this.info.checkStatus === '1';
    }
  },
  filters: {
    formateStatus(val) {
      let label = '';
      switch (val) {
        case '0':
          label = '审核中';
          break;
        case '1':
          label = '白名单';
          break;
        case '2':
          label = '未通过';
          break;
        default:
          label = '非白名单';
          break;
      }
      return label;
    },
    formateBtnText(val) {
      let btnText = '';
      switch (val) {
        case '0':
          btnText = '审核中';
          break;
        case '1':
          btnText = '审核中';
          break;
        case '2':
          btnText = '再次申请白名单';
          break;
        default:
          btnText = '申请白名单';
          break;
      }
      return btnText;
    }
  },
  data() {
    return {
      checked: true,
      info: {
        mercName: '',
        checkStatus: '',
        checkRemark: '',
        createTime: '',
        checkTime: '',
        mercNo: ''
      },
      requestData: {}
    };
  },
  activated() {
    if (this.$route.params.info) {
      const info = this.$route.params.info;
      Object.keys(this.info).forEach(key => {
        this.info[key] = info[key];
      });
    } else {
      this.requestData = {
        agentId: this.$route.params.agentId,
        mercNo: this.$route.params.mercNo
      }
      this.queryDetail();
    }
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    queryDetail() {
      this.$http.post({
        url: 'csps-api/MerWhitelist/selectMerWhiteByVo',
        data: this.requestData
      }).then(res => {
        console.log(res);
        Object.keys(this.info).forEach(key => {
          this.info[key] = res.data.result[key];
        });
      }).catch(error => {
        console.log(error);
      });
    },
    handleApply() {
      if (!this.checked) {
        this.$toast('请先勾选协议');
        return false;
      }
      const toast = this.$toast.loading({
        duration: 0,
        forbidClick: true,
        loadingType: 'spinner'
      });
      this.$http.post({
        url: 'csps-api/MerWhitelist/addMerWhiteByVo',
        data: {
          agentId: this.$route.params.agentId,
          mercNo: this.info.mercNo
        }
      }).then(res => {
        console.log(res);
        toast.clear();
        this.$dialog.alert({
          title: '提示',
          message: '提交成功，请耐心等待审核结果'
        }).then(() => {
          this.$router.go(-1);
        });
      }).catch(error => {
        console.log(error);
      });
    }
  }
};
</script>

<style scoped>
.item{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 10%;
  padding: 10px 0;
}
.item>p{
  font-size: 14px;
  color: #333333;
}
.item>p:first-child{
  color: #666666;
  flex: 0 0 100px;
}
.item>p:last-child{
  flex: auto;
}
.btn{
  margin: 10% 10% 20px;
  line-height: 45px;
  width: 80%;
  border: none;
  outline: none;
  color: #ffffff;
  font-size: 18px;
  background-color: #1D7BF9;
  border-radius: 25.5px;
}
button[disabled]{
  background: #F6F6F6;
  color: #474A56;
}
.checkBox{
  margin: 0 10%;
  font-size: 12px;
  color: #999999;
  display: flex;
}
</style>